import script from "./LayoutSwitch.vue?vue&type=script&setup=true&lang=js"
export * from "./LayoutSwitch.vue?vue&type=script&setup=true&lang=js"

import "./LayoutSwitch.vue?vue&type=style&index=0&id=0a7a0641&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0a7a0641"]])

export default __exports__